var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBell = function SvgBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.25V3.94844C15.832 4.39805 18 6.85156 18 9.8125V11.1172C18 12.8906 18.6055 14.6133 19.7109 16L20.293 16.7266C20.5195 17.0078 20.5625 17.3945 20.4063 17.7188C20.25 18.043 19.9219 18.25 19.5625 18.25H3.93751C3.57696 18.25 3.24864 18.043 3.09255 17.7188C2.93641 17.3945 2.98032 17.0078 3.20548 16.7266L3.7879 16C4.8961 14.6133 5.50001 12.8906 5.50001 11.1172V9.8125C5.50001 6.85156 7.66798 4.39805 10.5 3.94844V3.25C10.5 2.55977 11.0586 2 11.75 2C12.4414 2 13 2.55977 13 3.25ZM11.4375 5.75C9.19532 5.75 7.37501 7.57031 7.37501 9.8125V11.1172C7.37501 12.9883 6.83282 14.8125 5.82462 16.375H17.6758C16.668 14.8125 16.125 12.9883 16.125 11.1172V9.8125C16.125 7.57031 14.3047 5.75 12.0625 5.75H11.4375ZM14.25 19.5C14.25 20.1289 13.9883 20.8008 13.5195 21.2695C13.0508 21.7383 12.3789 22 11.75 22C11.0859 22 10.4492 21.7383 9.98048 21.2695C9.51173 20.8008 9.25001 20.1289 9.25001 19.5H14.25Z",
    fill: "#555"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell.1524d026.svg";
export { ForwardRef as ReactComponent };